if (!customElements.get("m-research-library")) {
  class MResearchLibrary extends HTMLElement {
    constructor() {
      super();
      this.papers = [];
      this.filtered = [];
      this.visible = 20;
      this.pageSize = 20;
      this.query = "";
      this.topic = "all";
      this.topics = {
        antioxidant: /antioxidant|oxidation|flavonoid|polyphenol/i,
        immune: /immune|immunomodul|immunostim|vaccine/i,
        hormone: /hormone|testosterone|androgen|steroid|gonadal|phyto/i,
        nutrition: /nutrient|nutritive|vitamin|composition/i,
        aging: /aging|antiaging|anti-aging|senile|senescence/i,
        composition: /extract|chemical|constituent|determination|analysis/i,
        review: /review|bibliometric|progress|survey/i,
      };
    }

    connectedCallback() {
      this.searchInput = this.querySelector("[data-rl-search]");
      this.chipButtons = this.querySelectorAll("[data-rl-chip]");
      this.list = this.querySelector("[data-rl-list]");
      this.meta = this.querySelector("[data-rl-meta]");
      this.empty = this.querySelector("[data-rl-empty]");
      this.more = this.querySelector("[data-rl-more]");
      this.onSearch = this.onSearch.bind(this);
      this.onChip = this.onChip.bind(this);
      this.onMore = this.onMore.bind(this);

      if (this.searchInput) this.searchInput.addEventListener("input", this.onSearch);
      this.chipButtons.forEach((button) => button.addEventListener("click", this.onChip));
      if (this.more) this.more.addEventListener("click", this.onMore);

      this.load();
    }

    disconnectedCallback() {
      if (this.searchInput) this.searchInput.removeEventListener("input", this.onSearch);
      this.chipButtons.forEach((button) => button.removeEventListener("click", this.onChip));
      if (this.more) this.more.removeEventListener("click", this.onMore);
    }

    async load() {
      const src = this.dataset.src;
      if (!src) return;
      try {
        const response = await fetch(src);
        this.papers = await response.json();
        this.applyFilters();
      } catch (error) {
        this.papers = [];
        this.filtered = [];
        this.render();
      }
    }

    onSearch(event) {
      this.query = event.target.value.trim().toLowerCase();
      this.visible = this.pageSize;
      this.applyFilters();
    }

    onChip(event) {
      const next = event.currentTarget.dataset.rlChip;
      this.topic = next || "all";
      this.visible = this.pageSize;
      this.chipButtons.forEach((button) => {
        button.classList.toggle("is-active", button.dataset.rlChip === this.topic);
      });
      this.applyFilters();
    }

    onMore() {
      this.visible += this.pageSize;
      this.render();
    }

    matchesTopic(paper) {
      if (this.topic === "all") return true;
      const pattern = this.topics[this.topic];
      return pattern ? pattern.test(paper.title) : true;
    }

    applyFilters() {
      this.filtered = this.papers.filter((paper) => {
        const haystack = `${paper.title} ${paper.authors}`.toLowerCase();
        const matchesQuery = !this.query || haystack.includes(this.query);
        return matchesQuery && this.matchesTopic(paper);
      });
      this.render();
    }

    render() {
      if (!this.list) return;
      const slice = this.filtered.slice(0, this.visible);
      this.list.innerHTML = slice.map((paper) => this.cardMarkup(paper)).join("");

      if (this.meta) {
        this.meta.textContent = `Showing ${slice.length} of ${this.filtered.length}`;
      }
      if (this.empty) {
        this.empty.hidden = this.filtered.length > 0;
      }
      if (this.more) {
        this.more.hidden = this.visible >= this.filtered.length;
      }
    }

    cardMarkup(paper) {
      const authors = paper.authors
        ? `<p class="m-research-library__card-authors">${this.escape(paper.authors)}</p>`
        : "";
      const link = paper.url
        ? `<a class="m-research-library__link" href="${this.escape(paper.url)}" target="_blank" rel="noopener noreferrer">Open paper</a>`
        : `<span class="m-research-library__link-placeholder"></span>`;

      return `
        <li class="m-research-library__card">
          <div>
            <h3 class="m-research-library__card-title">${this.escape(paper.title)}</h3>
            ${authors}
          </div>
          ${link}
        </li>
      `;
    }

    escape(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }
  }

  customElements.define("m-research-library", MResearchLibrary);
}
